import type { SportConfig, SportId } from '../types/sport';
import { volleyballConfig } from './volleyball';
import { footballConfig } from './football';
import { basketballConfig } from './basketball';
import { tennisConfig } from './tennis';
import { tableTennisConfig } from './table-tennis';
import { badmintonConfig } from './badminton';
import { beachVolleyballConfig } from './beach-volleyball';
import { hockeyConfig } from './hockey';

export const sportConfigs: Record<SportId, SportConfig> = {
  volleyball: volleyballConfig,
  football: footballConfig,
  basketball: basketballConfig,
  tennis: tennisConfig,
  table_tennis: tableTennisConfig,
  badminton: badmintonConfig,
  beach_volleyball: beachVolleyballConfig,
  hockey: hockeyConfig,
};

export const SPORT_IDS: SportId[] = Object.keys(sportConfigs) as SportId[];

export function getSportConfig(id: SportId): SportConfig {
  return sportConfigs[id];
}

export {
  volleyballConfig,
  footballConfig,
  basketballConfig,
  tennisConfig,
  tableTennisConfig,
  badmintonConfig,
  beachVolleyballConfig,
  hockeyConfig,
};
